"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.8 16.5",
    width: "31.8",
    height: "16.5"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M24.2,16.3c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5c1.4,0,2.5,1.1,2.5,2.5S25.6,16.3,24.2,16.3z M24.2,12.3c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S25.1,12.3,24.2,12.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M21.5,14.3h-4.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h4.2c0.3,0,0.5,0.2,0.5,0.5S21.8,14.3,21.5,14.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    stroke: "#97BF0D",
    d: "M17.5,13.8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    stroke: "#97BF0D",
    d: "M12.3,13.8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M12.2,14.3H9.8c-0.3,0-0.5-0.2-0.5-0.5v-9l0.1-4c0-0.3,0.2-0.5,0.5-0.5h8.6c0.3,0,0.5,0.2,0.5,0.5 s-0.2,0.5-0.5,0.5h-8.1l0,3.5v8.5h1.9c0.3,0,0.5,0.2,0.5,0.5S12.5,14.3,12.2,14.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    stroke: "#97BF0D",
    d: "M18.5,0.8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    stroke: "#97BF0D",
    d: "M27.7,0.8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M31.3,14.3h-4.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3.9v-12h-3c-0.3,0-0.5-0.2-0.5-0.5 s0.2-0.5,0.5-0.5h3.5c0.3,0,0.5,0.2,0.5,0.5v13C31.8,14.1,31.5,14.3,31.3,14.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M11.6,14.3H0.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h11.1c0.3,0,0.5,0.2,0.5,0.5S11.8,14.3,11.6,14.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M14.8,16.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5c1.4,0,2.5,1.1,2.5,2.5S16.2,16.5,14.8,16.5z M14.8,12.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S15.7,12.5,14.8,12.5z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#9ECE06",
    cx: "22.9",
    cy: "4.3",
    r: "4.3"
  }));
};

exports["default"] = _default;